import React from 'react';
import {useTranslation} from 'react-i18next';
import {Row, Col} from 'reactstrap';
import {Select, DatePicker} from '@/Form';
import {buildSelectOptions} from '@/components/Form/formHelper';

const PolicyOwner = () => {
  const {t: tr} = useTranslation('selection');

  return (
    <Row>
      <Col md={12}>
        <Row>
          <Col md={4}>
            <Select name='dateType'>
              {buildSelectOptions(tr('client_date_options'))}
            </Select>
          </Col>
          <Col md={2}>
            <DatePicker name='dateFrom' />
          </Col>
          <Col md={2} className='pl-1'>
            <DatePicker name='dateTo' />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default PolicyOwner;
